import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"stroke":"none","fill-rule":"nonzero","fill":"rgb(0%,0%,0%)","fill-opacity":"1"},
      d: "M7 11h18v13H7V11Z",
      fill: "black"
    }, null, -1),
    _createElementVNode("path", {
      style: {"stroke":"none","fill-rule":"nonzero","fill":"rgb(0%,0%,0%)","fill-opacity":"1"},
      d: "M0 6c0-3.3 2.7-6 6-6s6 2.7 6 6v5h-2V6c0-2.219-1.781-4-4-4-2.219 0-4 1.781-4 4v5H0V6Z",
      fill: "black"
    }, null, -1)
  ]))]))
}
export default { render: render }